// Simple in-memory store for media playback progress per stop.
// Shared between MapCard and StopDetails to sync audio/video position.
// Resets on page refresh (intentional — SPA only).

const store = new Map<string, { audio?: number; maxAudio?: number; video?: number }>();

export const mediaProgressStore = {
  getAudio(stopId: string): number {
    return store.get(stopId)?.audio ?? 0;
  },
  setAudio(stopId: string, time: number) {
    const entry = store.get(stopId) ?? {};
    entry.audio = time;
    if (!entry.maxAudio || time > entry.maxAudio) entry.maxAudio = time;
    store.set(stopId, entry);
  },
  /** Returns the furthest point reached across all sessions (MapCard + StopDetails) */
  getMaxAudio(stopId: string): number {
    return store.get(stopId)?.maxAudio ?? 0;
  },
  /** Returns combined percent listened (0-100) based on max position reached */
  getAudioPercent(stopId: string, duration: number): number {
    if (duration <= 0) return 0;
    const max = store.get(stopId)?.maxAudio ?? 0;
    return Math.min(100, Math.round((max / duration) * 100));
  },
  getVideo(stopId: string): number {
    return store.get(stopId)?.video ?? 0;
  },
  setVideo(stopId: string, time: number) {
    const entry = store.get(stopId) ?? {};
    entry.video = time;
    store.set(stopId, entry);
  },
  clear(stopId: string) {
    store.delete(stopId);
  },
};
